// SimpleEntityProfileTag.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, Tag } from 'antd';
import translateX from 'utils/translateX';
import appService from 'services/appService';
import entitiesService from 'services/entitiesService';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************

export const SimpleEntityProfileTag = ({
  tags = [],
  className,
  gap = '4px 0',
  align = 'left',
  direction = 'horizontal',
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const justify = align === 'right' ? 'flex-end' : 'flex-start';
  const isVertical = direction === 'vertical' || appService.isMobile();
  const entityProfile = tags ? (Array.isArray(tags) ? tags : [tags]) : null;
  const space = 6;

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  // const handleClick = profile => {
  //   console.log('profile', profile, 'onClick');
  // };

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return entityProfile?.length ? (
    <Flex
      gap={gap}
      wrap
      justify={justify}
      style={{ flexDirection: isVertical ? 'column' : 'row', alignItems: 'center' }}
    >
      {entityProfile.map((profile, idx) => (
        <Tag
          key={idx}
          color={entitiesService.getEntityProfileColor(profile)}
          // onClick={() => handleClick(profile)}
          style={{
            margin: 0,
            marginLeft: !isVertical ? (align === 'right' ? space : 0) : 0,
            marginRight: !isVertical ? (align !== 'right' ? space : 0) : 0,
            marginBottom: isVertical ? space : 0,
          }}
        >
          <span className={className}>{translateX(profile)}</span>
        </Tag>
      ))}
    </Flex>
  ) : null;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleEntityProfileTag;
